// ■■■■■■■■■■■■■■■■■■■■ LIBS : ■■■■■■■■■■■■■■■■■■■■
import { useState } from "react";
import {  useSelector,   useDispatch  } from "react-redux";
import Button from 'react-bootstrap/Button';

// ■■■■■■■■■■■■■■■■■■■■ HELPERS : ■■■■■■■■■■■■■■■■■■■■
import { apiEleveEdit, apiEleveCreate, apiEleveDelete } from '../../api/cmzApi'


// ■■■■■■■■■■■■■■■■■■■■ COMPONENTS : ■■■■■■■■■■■■■■■■■■■■
import Loading from '../_nav/Loading'


// ■■■■■■■■■■■■■■■■■■■■ CSS : ■■■■■■■■■■■■■■■■■■■■



// █████████████████████████████████████████████████████████████████████████████



export default function FormEleve({eleve, setEleve, etabId}) {


	const app = useSelector((state) => state.app)
  	const dispatch = useDispatch();



	const [isLoading, setIsLoading] = useState(false);
	const [deleteErrorMessage, setDeleteErrorMessage] = useState(null)

	const [id, setId] = useState(eleve.id)
	const [nom, setNom] = useState(eleve.nom)
	const [prenom, setPrenom] = useState(eleve.prenom)
	const [classe, setClasse] = useState(eleve.classe)
	const [regime, setRegime] = useState(eleve.regime)
	const [prioLundi, setPrioLundi] = useState(eleve.prioLundi)
	const [prioMardi, setPrioMardi] = useState(eleve.prioMardi)
	const [prioMercredi, setPrioMercredi] = useState(eleve.prioMercredi)
	const [prioJeudi, setPrioJeudi] = useState(eleve.prioJeudi)
	const [prioVendredi, setPrioVendredi] = useState(eleve.prioVendredi)
	const [commentaire, setCommentaire] = useState(eleve.commentaire)
	const [actif, setActif] = useState(eleve.actif)
	const [numeroCarte, setNumeroCarte] = useState(eleve.numeroCarte)


//	console.log(app.etab)

	function handleSubmitEdit(){

		setIsLoading(true)

		apiEleveEdit(id, nom, prenom, classe, regime, prioLundi, prioMardi, prioMercredi, prioJeudi, prioVendredi, commentaire, actif, numeroCarte)
			.then(
				(result) => {
					//console.log(result)
					if(result.eleve){
						dispatch({type:"UPDATE_ELEVE", payload: result.eleve})
					}
					closeForm()
					setIsLoading(false)
				},
				(error) => {
					setIsLoading(false)
			   		// TODO
					console.log("error")
					console.log(error)
				}
			)

	}

	function handleSubmitCreate(){

		setIsLoading(true)

		apiEleveCreate(etabId, nom, prenom, classe, regime, prioLundi, prioMardi, prioMercredi, prioJeudi, prioVendredi, commentaire, actif, numeroCarte)
			.then(
				(result) => {
					console.log(result)
					if(result.eleve){
						dispatch({type:"CREATE_ELEVE", payload: result.eleve})
					}
					closeForm()
					setIsLoading(false)
				},
				(error) => {
					setIsLoading(false)
			   		// TODO
					console.log("error")
					console.log(error)
				}
			)

	}

	function handleDelete(){

	//	alert("Cette fonction est momentanement désactivée")
	//	return null
		if ( ! window.confirm('Voulez-vous vraiment supprimer cet élève ?')){
			return
		}

		if ( ! window.confirm("Si l'élève ne mangera plus à la cantine, il ne faut pas le supprimer, mais le passer inactif ! Voulez-vous quand même le supprimer ?")){
			return
		}


		if ( ! window.confirm("En cliquant sur \"OK\", vous allez supprimer cet élève ainsi que tout ses appels ? ")){
			return
		}



		setIsLoading(true)
		apiEleveDelete(eleve.id)
			.then(
				(result) => {
					console.log(result)
					if (result.REPONSE && result.REPONSE==="OK"){
						dispatch({type:"DELETE_ELEVE", payload: eleve.id})
						setIsLoading(false)
						closeForm()
					}
					else{
						console.log(result)
						alert('error')
						result.detail && setDeleteErrorMessage(result.detail)
					}


				},
				(error) => {
					setIsLoading(false)
			   		// TODO
					console.log("error")
					console.log(error)
				}
			)

	}


	function closeForm(){
		setEleve(null)
	}



    return (

		<div className="zxModalContainer"  >
			<div className="zxModalOpaqueBackground"></div>

			<form className="row col-12 zxModal" style={{width: "800px"}}>


				<div className="row col-12 formHeader mb-5"	>
					<h4>
					{eleve.id ?
						<>Modifier l'élève : <b>{eleve.nom + " " + eleve.prenom}</b></>
						:
						<>Ajouter un élève (ou AED)</>
					}
					</h4>

					{eleve.id !== null &&

						<div className=" col-12"	>
							<Button
								className="btn btn-danger btn-xs float-end"
								title="Supprimer cet periode"
								onClick={()=>handleDelete()}
							>
								Supprimer
							</Button>
						</div>
					}

				</div>



				<div className="row col-12 deleteUserErrorMessage">
					{deleteErrorMessage}
				</div>



				<div className="row col-12 fields">

					<div className="col-6 fields-left">
						<label className="col-12 field">
							Nom
							<input className="float-end" value={nom} name="nom" autoFocus onChange={(event)=>setNom(event.target.value)}	/>
						</label>
						<label className="col-12 field">
							Prénom
							<input className="float-end" value={prenom} name="prenom" onChange={(event)=>setPrenom(event.target.value)}	/>
						</label>
						<label className="col-12 field">
							Classe (ou "AED")
							<input className="float-end" value={classe} name="classe" onChange={(event)=>setClasse(event.target.value)}	/>
						</label>
						<label className="col-12 field">
							Régime <small>(celui de pronote)</small>
							<select
							 	className="float-end"
								name="regime"
								id="regime"
								onChange={(event)=>setRegime(event.target.value)}
								value={regime}
							>
								<option value="">?</option>
							    <option value="EXT">Externe</option>
							    <option value="DP">Demi-pensionnaire</option>
							</select>
						</label>
						<label className="col-12 field">
							Numero de carte
							<input className="float-end" value={numeroCarte} name="numeroCarte" onChange={(event)=>setNumeroCarte(event.target.value)}	/>
						</label>
						<label className="col-12 field mt-3 mb-3">
							Actif <small>(décochez s'il ne mangera plus à la cantine)</small>
							<input
							 	className="float-end"
					          	type="checkbox"
					          	checked={actif}
					          	onChange={()=>setActif(!actif)}
					        />
						</label>
					</div>

					<div className="col-6 fields-left">
						<label className="col-12 field">
							Prio Lundi
							<input className="float-end" value={prioLundi} name="prioLundi" onChange={(event)=>setPrioLundi(event.target.value)}	/>
						</label>
						<label className="col-12 field">
							Prio Mardi
							<input className="float-end" value={prioMardi} name="prioMardi" onChange={(event)=>setPrioMardi(event.target.value)}	/>
						</label>
						<label className="col-12 field">
							Prio Mercredi
							<input className="float-end" value={prioMercredi} name="prioMercredi" onChange={(event)=>setPrioMercredi(event.target.value)}	/>
						</label>
						<label className="col-12 field">
							Prio Jeudi
							<input className="float-end" value={prioJeudi} name="prioJeudi" onChange={(event)=>setPrioJeudi(event.target.value)}	/>
						</label>
						<label className="col-12 field">
							Prio Vendredi
							<input className="float-end" value={prioVendredi} name="prioVendredi" onChange={(event)=>setPrioVendredi(event.target.value)}	/>
						</label>
						<label className="col-12 field mt-3 mb-3">
							Foyer <small>(bientôt !)</small>
							<input
							 	className="float-end"
					          	type="checkbox"
					          	checked={false}
					          	//onChange={()=>setActif(!actif)}
					        />
						</label>
					</div>

					<div className="col-12  fields-left">
						<label className="col-12 row field">
							<div className="col-3">Commentaire</div>
							<input value={commentaire}  className="col-9" name="commentaire" onChange={(event)=>setCommentaire(event.target.value)}	/>
						</label>
					</div>

				</div>








				{ isLoading ? (<Loading />) : (
					<div className="col-12 mt-5 zone-boutons">




						{eleve.id !== null ? (
							<Button
								className="btn btn-success col-4"
								onClick={()=>handleSubmitEdit()}
								tabIndex="0"
							>
								Modifier
							</Button>
						): (
							<Button
								className="btn btn-success col-4"
								onClick={()=>handleSubmitCreate()}
								tabIndex="0"
							>
								Ajouter
							</Button>
						)}

						<Button
							className="btn btn-danger col-4 float-end"
							onClick={()=>closeForm()}
							tabIndex="0"
							>
							Annuler
						</Button>
					</div>
				)}


			</form>


		</div>
    );
  }
